import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fs-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.sass']
})

export class AppLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
